import React from 'react';
import Display from './parts/display';

class ClientsBlock extends React.Component {
    constructor() {
        super();
        this.state = {
            visible: 8
        };
        this.displayClients = this.displayClients.bind(this);
        this.updateVisible = this.updateVisible.bind(this);
    }
    componentDidMount(){

    }
    componentWillReceiveProps(next) {
        var _this = this;
        if(this.props.clients !== next.clients){
            this.setState({
                visible: 8
            });
        }
    }
    updateVisible(){
        this.setState({
            visible: this.state.visible === 8? this.props.clients.length : 8
        });
    }
    displayClients(client, index){
        if(client.acf.branding && index < this.state.visible) return <div className="client-brand col-md-3 col-xs-6" key={index}><div className="content"><img src={client.acf.branding} /></div></div>;
    }
    render() {
        return (
            <Display if={this.props.clients.length > 0}>
                <div className="client-section">
                    <div className="container">
                        <div className="row">
                            <h3>Clients</h3>
                            <div className={this.state.visible === 8? "client-brands": "client-brands sixteen"}>
                                {this.props.clients.map(this.displayClients)}
                            </div>

                            <div className={this.state.visible === 8? "load-more-arrow show-more": "load-more-arrow  show-more less"} onClick={this.updateVisible}><i className={this.state.visible === 8? "fa fa-angle-down": "fa fa-angle-up"}></i></div>
                        </div>
                    </div>
                </div>
            </Display>
        );
    }
}

export default ClientsBlock;



/** WEBPACK FOOTER **
 ** ./src/js/components/clientsBlock.js
 **/